import { put, call } from "redux-saga/effects";
import { push } from "react-router-redux";
import Swal from "sweetalert2";

import {
    getEvaluationSuccess,
    getEvaluationFail,
    getAllEvaluationsSuccess,
    getAllEvaluationsFail,
    getEvaluationsByTypeSuccess,
    getEvaluationsByTypeFail,
    createEvaluationSuccess,
    createEvaluationFail,
    updateEvaluationSuccess,
    updateEvaluationFail,
    deleteEvaluationSuccess,
    deleteEvaluationFail,
    changeEvaluationStatusSuccess,
    changeEvaluationStatusFail,
    setEvaluationLoading
} from "../actions/evaluationActions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
} from "../../../api";

// ========================================
// GET ONE
// ========================================
export function* getEvaluationSaga(action) {
    const url = `${API_BASE_URL}/api/evaluations/${action.payload.evaluationId}`;
    const token = sessionStorage.getItem("token");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 GET_EVALUATION_REQUEST");
        console.log("📊 Evaluation ID:", action.payload.evaluationId);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group("✅ GET_EVALUATION_SUCCESS");
        console.log("📥 Réponse API:", resp.data);
        console.groupEnd();

        yield put(getEvaluationSuccess(resp.data));
        yield put(setEvaluationLoading(false));
    } catch (error) {
        console.group("❌ GET_EVALUATION_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(getEvaluationFail(error.response?.data?.message || error.message));
        yield put(setEvaluationLoading(false));
    }
}

// ========================================
// GET ALL
// ========================================
export function* getAllEvaluationsSaga() {
    const url = `${API_BASE_URL}/api/evaluations`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 GET_ALL_EVALUATIONS_REQUEST");
        console.groupEnd();

        const resp = yield call(getRequest, {
            url,
            token,
            extraHeaders: { uid }
        });

        console.group("✅ GET_ALL_EVALUATIONS_SUCCESS");
        console.log("📥 Nombre d'évaluations:", resp.data.length);
        console.groupEnd();

        yield put(getAllEvaluationsSuccess(resp.data));
        yield put(setEvaluationLoading(false));
    } catch (error) {
        console.group("❌ GET_ALL_EVALUATIONS_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(getAllEvaluationsFail(error.response?.data?.message || error.message));
        yield put(setEvaluationLoading(false));
    }
}

// ========================================
// GET BY TYPE
// ========================================
export function* getEvaluationsByTypeSaga(action) {
    const url = `${API_BASE_URL}/api/evaluations/type/${action.payload.typeCode}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 GET_EVALUATIONS_BY_TYPE_REQUEST");
        console.log("📊 Type:", action.payload.typeCode);
        console.groupEnd();

        const resp = yield call(getRequest, {
            url,
            token,
            extraHeaders: { uid }
        });

        console.group("✅ GET_EVALUATIONS_BY_TYPE_SUCCESS");
        console.log("📥 Nombre d'évaluations:", resp.data.length);
        console.groupEnd();

        yield put(getEvaluationsByTypeSuccess(resp.data));
        yield put(setEvaluationLoading(false));
    } catch (error) {
        console.group("❌ GET_EVALUATIONS_BY_TYPE_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(getEvaluationsByTypeFail(error.response?.data?.message || error.message));
        yield put(setEvaluationLoading(false));
    }
}

// ========================================
// CREATE
// ========================================
export function* createEvaluationSaga(action) {
    const url = `${API_BASE_URL}/api/evaluations`;
    const data = action.payload;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 CREATE_EVALUATION_REQUEST");
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(postRequest, {
            url,
            data,
            token,
            extraHeaders: { uid }
        });

        console.group("✅ CREATE_EVALUATION_SUCCESS");
        console.log("📥 Évaluation créée:", resp.data);
        console.groupEnd();

        yield put(createEvaluationSuccess(resp.data));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Évaluation créée avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push("/evaluations"));
        }
    } catch (error) {
        console.group("❌ CREATE_EVALUATION_FAIL");
        console.error("🚨 Erreur:", error);
        console.groupEnd();

        const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Erreur lors de la création";

        yield put(createEvaluationFail(errorMessage));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: errorMessage,
            confirmButtonText: "OK"
        });
    }
}

// ========================================
// UPDATE
// ========================================
export function* updateEvaluationSaga(action) {
    const url = `${API_BASE_URL}/api/evaluations/${action.payload.evaluationId}`;
    const data = action.payload.evaluationData;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 UPDATE_EVALUATION_REQUEST");
        console.log("📊 Evaluation ID:", action.payload.evaluationId);
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(putRequest, {
            url,
            data,
            token,
            extraHeaders: { uid }
        });

        console.group("✅ UPDATE_EVALUATION_SUCCESS");
        console.log("📥 Évaluation mise à jour:", resp.data);
        console.groupEnd();

        yield put(updateEvaluationSuccess(resp.data));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Évaluation mise à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push("/evaluations"));
        }
    } catch (error) {
        console.group("❌ UPDATE_EVALUATION_FAIL");
        console.error("🚨 Erreur:", error);
        console.groupEnd();

        const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Erreur lors de la mise à jour";

        yield put(updateEvaluationFail(errorMessage));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: errorMessage,
            confirmButtonText: "OK"
        });
    }
}

// ========================================
// DELETE
// ========================================
export function* deleteEvaluationSaga(action) {
    const url = `${API_BASE_URL}/api/evaluations/${action.payload.evaluationId}`;
    const token = sessionStorage.getItem("token");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 DELETE_EVALUATION_REQUEST");
        console.log("📊 Evaluation ID:", action.payload.evaluationId);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group("✅ DELETE_EVALUATION_SUCCESS");
        console.log("🗑️ Évaluation supprimée");
        console.groupEnd();

        yield put(deleteEvaluationSuccess(action.payload.evaluationId));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Évaluation supprimée avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push("/evaluations"));
        }
    } catch (error) {
        console.group("❌ DELETE_EVALUATION_FAIL");
        console.error("🚨 Erreur:", error);
        console.groupEnd();

        const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Erreur lors de la suppression";

        yield put(deleteEvaluationFail(errorMessage));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33"
        });
    }
}

// ========================================
// CHANGE STATUS
// ========================================
export function* changeEvaluationStatusSaga(action) {
    const { evaluationId, status } = action.payload;
    const url = `${API_BASE_URL}/api/evaluations/${evaluationId}/status?status=${status}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setEvaluationLoading(true));

    try {
        console.group("🔵 CHANGE_EVALUATION_STATUS_REQUEST");
        console.log("📊 Evaluation ID:", evaluationId);
        console.log("📊 Status:", status);
        console.groupEnd();

        const resp = yield call(putRequest, {
            url,
            data: {},
            token,
            extraHeaders: { uid }
        });

        console.group("✅ CHANGE_EVALUATION_STATUS_SUCCESS");
        console.log("📥 Évaluation:", resp.data);
        console.groupEnd();

        yield put(changeEvaluationStatusSuccess(resp.data));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Statut modifié avec succès",
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        console.group("❌ CHANGE_EVALUATION_STATUS_FAIL");
        console.error("🚨 Erreur:", error);
        console.groupEnd();

        const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Erreur lors du changement de statut";

        yield put(changeEvaluationStatusFail(errorMessage));
        yield put(setEvaluationLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: errorMessage,
            confirmButtonText: "OK"
        });
    }
}